import {RiskProfileInput, RiskType} from '../../schema-types/globalTypes';
import {UpsertRiskNoteVariables} from '../../schema-types/UpsertRiskNote';

import {riskNotesFormType} from './riskNotesFields';

export const riskNotesFormToVariables = (
  contactIds: string[],
  values: riskNotesFormType,
  reviewId: string
) => {
  const variables: UpsertRiskNoteVariables = {
    inputs: [],
  };
  for (const contactId of contactIds) {
    const profile: RiskProfileInput = {
      reviewId,
      contactId,
      centralPropositionAgreed: values.centralPropositionAgreed || false,
      dfmAgreed: values.dfmAgreed || false,
      noChangeReasonNotes: values.noChangeReasonNotes,
      outcomeRiskScore: values.outcomeRisk[contactId]?.score,
      outcomeRiskNotes: values.outcomeRisk[contactId]?.notes,
      riskToleranceQuestionnaireDeclineReason: values.outcomeRisk[contactId]
        ?.isRiskToleranceQuestionnaireDeclined
        ? values.outcomeRisk[contactId]?.riskToleranceQuestionnaireDeclineReason?.trim()
        : undefined,
      hasNoRiskDicussion: values.hasNoRiskDicussion,
      isRiskToleranceQuestionnaireDeclined:
        values.outcomeRisk[contactId]?.isRiskToleranceQuestionnaireDeclined,
    };
    variables.inputs.push(profile);
  }
  return variables;
};

/**
 * "Risk outcome" sections are hidden when
 * - the user explicitly ticked "No risk discussion", or
 * - every risk section has been marked as no change.
 */
export const shouldHideRiskOutcomeSections = ({
  hasNoRiskDicussion,
  allNoChanges,
}: {
  hasNoRiskDicussion: boolean;
  allNoChanges: boolean;
}): boolean => Boolean(hasNoRiskDicussion) || allNoChanges;

// The risk-notes flow drives the new 3-section UI introduced by ON-9175.
// `as const` narrows the element type to the union of these three enum
// members, keeping the indexers into `riskNotesFormType` (which only
// declares the three new keys) type-checking.
export const riskSegmentsOrderedByBusinessLogic = [
  RiskType.KNOWLEDGE_AND_BEHAVIOUR,
  RiskType.VALUES_AND_SERVICE,
  RiskType.FINANCIAL_CAPACITY,
] as const;
